import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';


import Documents from '../../components/Documents';
import { selectAuthenticatedUser } from '../../store/selectors/auth'
import { fetchFaqsNotesDocuments, saveFaqsNotesDocuments, deleteFaqsNotesDocuments, deleteOnboardingDocument } from '../../store/actions/faqsNotesDocuments';
import { selectDocuments } from '../../store/selectors/faqsNotesDocuments';
import { setSearch, clearSearch } from '../../store/actions/search';
import { upload } from '../../helpers/uploadDocument';
import moment from 'moment';
import { fetchSuiteCounts } from '../../store/actions/suites';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import Loader from '../../components/Loader';
import { startFormLoading } from '../../store/actions/loader';
import {sortDocumentsList} from "../../helpers/CommonHelpers"
class SuiteDocuments extends Component {
  componentDidMount(){
    this.props.clearSearch()
    this.props.onFetchFaqsNotesDocuments(this.props.suite.id,'SuiteAssets')
  }


  onSave = async (document) => {
    this.props.onStartFormLoading();
    let image = null
    if(document && document.image && document.image.length > 0 && document.image[0].path){
      let path = document.image[0].path;
      let newFileName = path.split(/\.(?=[^\.]+$)/)[0] + moment().format('MMDDYYYYhmmss') + '.' + path.split(/\.(?=[^\.]+$)/)[1]
      image =  await upload(document.image[0], newFileName.replace(/ /g,''))
      document = document = {...document,image}
    }
    const { uploadType, ...documentData } = document;
    let data = {
      ItemId: this.props.suite.id,
      Name: 'DOCUMENTS',
      Type: 'DOCUMENTS',
      Data: JSON.stringify(documentData).toString(),
      UserId: this.props.user.id,
      isImportantDocument: document.isImportantDocument
    }
    await this.props.onSaveFaqsNotesDocuments(data)
    this.props.onFetchSuiteCounts(this.props.suite.id,this.props.user.roles[0].role.name);


  }
  onDeleteFaqsNotesDocuments = async (document) =>{
    document.Type = 'DOCUMENTS';
    if(document.documentType === 'Onboarding') {
      document.userId = this.props.user.id;
      await this.props.onDeleteOnboardingDocument(document);
      this.props.onFetchSuiteCounts(this.props.suite.id,this.props.user.roles[0].role.name);
    } else {
      await this.props.onDeleteFaqsNotesDocuments(document)
      this.props.onFetchSuiteCounts(this.props.suite.id,this.props.user.roles[0].role.name);
    }
  }
  render() {
    const { documents, suite, setSearch,loader  } = this.props;
    const sortDocuments = sortDocumentsList(documents)

    return (
      loader ? <Loader /> :
      <Documents
        breadcrumb={suite.number}
        documents={sortDocuments}
        onSaveDocument={ (document) => this.onSave(document)}
        onDeleteDocument={(document) => this.onDeleteFaqsNotesDocuments(document)}
        onSearch={e => setSearch({ documents: e.target.value.trim() })}
        labelName={"Manuals & Documents"}
        from={'Suite'}
        introContent={true}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user:selectAuthenticatedUser(state),
  documents: selectDocuments(state),
  loader: selectPRLoader(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchFaqsNotesDocuments: fetchFaqsNotesDocuments,
  onSaveFaqsNotesDocuments:saveFaqsNotesDocuments,
  setSearch,
  clearSearch,
  onDeleteFaqsNotesDocuments: deleteFaqsNotesDocuments,
  onDeleteOnboardingDocument: deleteOnboardingDocument,
  onFetchSuiteCounts: fetchSuiteCounts,
  onStartFormLoading: startFormLoading
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SuiteDocuments);
